import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { firestore } from "../firebase-config";

// The one and only per-USER (not per-company) Firestore doc in this app - everything else here
// lives on the company doc or one of its subcollections, but a "favourite desk room" is inherently
// personal rather than something shared with the rest of the company, so it gets its own tiny doc
// keyed by uid (companies/{companyId}/user_preferences/{uid}) instead of being forced into a
// company-wide settings shape. See firestore.rules' matching `user_preferences/{uid}` block - only
// the user themselves can ever read or write their own doc here, not even Admin/Super.
const userPreferencesDocRef = (companyId, uid) => doc(firestore, "companies", companyId, "user_preferences", uid);

export async function getFavouriteDeskRoomId(companyId, uid) {
  if (!companyId || !uid) {
    return null;
  }
  const snap = await getDoc(userPreferencesDocRef(companyId, uid));
  return snap.exists() ? snap.data()?.favourite_desk_room_id ?? null : null;
}

// `roomId` of null/undefined clears the preference entirely (stored as an explicit null rather
// than deleting the doc, since a future preference could live alongside this one on the same doc).
export async function setFavouriteDeskRoomId(companyId, uid, roomId) {
  await setDoc(
    userPreferencesDocRef(companyId, uid),
    { favourite_desk_room_id: roomId ?? null, updated_at: serverTimestamp() },
    { merge: true }
  );
}

// Whether Harcast's "Add Time" dialog pre-fills itself from the previous day's entry (Profile >
// Autofill Harcast Time). On unless the person has explicitly switched it off, so a missing doc or
// field - i.e. everyone who's never touched the setting - counts as enabled.
export async function getHarvestAutofillEnabled(companyId, uid) {
  if (!companyId || !uid) {
    return true;
  }
  const snap = await getDoc(userPreferencesDocRef(companyId, uid));
  return snap.exists() ? snap.data()?.harvest_autofill_previous_day ?? true : true;
}

export async function setHarvestAutofillEnabled(companyId, uid, enabled) {
  await setDoc(
    userPreferencesDocRef(companyId, uid),
    { harvest_autofill_previous_day: Boolean(enabled), updated_at: serverTimestamp() },
    { merge: true }
  );
}
